import { trackingPageOrderSchema } from "@redotech/redo-model/order-tracking/tracking-page-order-definition";
import * as z from "zod/v4";

export const getRecentOrders = {
  name: "getRecentOrders" as const,
  input: z.object({ limit: z.number().min(1).max(50).default(10).optional() }),
  output: z.object({ orders: z.array(trackingPageOrderSchema) }),
};
